import { usePaginationState } from '@vtex/admin-ui'
import { useMemo } from 'react'
import { Item } from 'typings'

export const PAGE_SIZE = 25

type Props = {
  items: Item[]
}

export function usePagination(props: Props) {
  const { items } = props

  const paginationState = usePaginationState({
    pageSize: PAGE_SIZE,
    total: items.length,
  })

  const { range } = paginationState

  const pageItems = useMemo(() => {
    const startPage = range[0] - 1
    const endPage = range[1]
    return items.slice(startPage, endPage)
  }, [items, range])

  return {
    paginationState,
    pageItems,
  }
}
